/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

export function getCustomOrderList(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/list`, {
        method: 'post',
        body: {...param}
    });
}

export function detail(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/details`, {
        method: 'post',
        body: {...param}
    });
}

// 点击搜索
export function getPro(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/selectCusOrderPro`, {
        method: 'post',
        body: param
    });
}

export function getCrmAccount(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/getCrmAccount?name=${param}`, {
        method: 'get'
    });
}

//加入购物车
export function addCar(param) {
    return request(`${config.server}/api/v1/dms/shoppingCart/insert`, {
        method: 'post',
        body: param
    });
}


// 已有物料
export function getProTypes(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/selectProType`, {
        method: 'post',
        body: {...param}
    });
}

// 提交按钮
export function create(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/create`, {
        method: 'post',
        body: {...param}
    });
}

// 产品规格列表
export function fetchSpecList(param) {
    return request(`${config.server}/api/v1/dms/product/category/${param}`, {
        method: 'get'
    });
}

// 生产公司下拉列表
export function fetchCompany(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/factory?categoryId=${param}`, {
        method: 'get'
    });
}

/**
 * 产品分类 get
 * @param param
 * @returns {*}
 */
export function getProductCategory() {
    return request(`${config.server}/api/v1/dms/category/listTree`, {
        method: 'get'
    });
}

/*获取生产公司联系方式*/
export function getCompanyLink(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/companyLink`, {
        method: 'post',
        body: {...param}
    });
}

/*修改并保存生产公司联系方式*/
export function updateCompanyLink(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/updateList`, {
        method: 'post',
        body: {...param}
    });
}

/*删除*/
export function deleteLink(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/deleteLink`, {
        method: 'post',
        body: param
    });
}

/*删除*/
export function addLink(param) {
    return request(`${config.server}/api/v1/dms/tgCustomOrder/insertList`, {
        method: 'post',
        body: param
    });
}


// WEBPACK FOOTER //
// ./src/service/customOrder/index.js